module.exports = __webpack_public_path__ + "static/media/app-features.0a175457.png";